import { Injectable } from '@angular/core';
import { RankingApi } from './ranking.api';
import { iRankingBet, iRankingRow } from './ranking.interface';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RankingService {

  constructor(
		private api: RankingApi,
	) { }

	private getRankingFromData(data:any): iRankingRow {
		return {
			position: data["position"],
			points: data["points"],
			name: data["user"],
			location: data["location"],
			sent: data["sent_in"],
			deaths: data["deaths"].map((d: any) => this.getBetFromRankingRow(d)),
		};
	}
	private getBetFromRankingRow(data: any): iRankingBet {
		return {
			id: data["id"],
			name: data["name"],
			points: data["points"],
		};
	}

	public getFullRanking(): Observable<iRankingRow[]> {
		return this.api.getFullRanking()
			.pipe(
				map((rs:any) => rs.map((r:any) => this.getRankingFromData(r)))
			);
	}

}
